import React from 'react';
import moment from 'moment';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import PropTypes from 'prop-types';
import MomentUtils from '@date-io/moment';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';

export default class DateField extends React.Component {
    constructor(props) {
        super(props);

        this.onChangeValue = null;
    }

    render() {
        const {
            id,
            title,
            options,
            emptyValue,
            placeholder,
            error,
            errorText,
            helperText,
            required,
            disabled,
            inputValue,
            onBlur,
            onFocus,
            uiSchema
        } = this.props;

        const { classes = {} } = uiSchema;
        const optionalProps = [];
        const onChange = value => {
            this.onChangeValue = value;
            this.props.onChange(id, value === '' ? emptyValue : value);
        };

        const views = ['year', 'month', 'date'];

        let convertedValue = inputValue;

        if (!(inputValue instanceof Date || inputValue instanceof moment)) {
            convertedValue = null;
        }

        if (options.minDate) {
            optionalProps.minDate = options.minDate;
        }

        if (options.maxDate) {
            optionalProps.maxDate = options.maxDate;
        }

        if (options.useStepViews) {
            optionalProps.views = views;
            optionalProps.openTo = 'year';
        }

        if (options.autoOk) {
            optionalProps.autoOk = options.autoOk;
        }

        return (
            <React.Fragment>
                <FormControl
                    required={ required }
                    error={ error }
                    component="fieldset"
                    classes={{
                        root: classes.fieldSet || ''
                    }}
                >
                    <MuiPickersUtilsProvider utils={ MomentUtils }>
                        <KeyboardDatePicker
                            clearable={ options.clearable ? 'true' : 'false' }
                            id={ id }
                            label={ title }
                            classes={{
                                root: classes.dateField || ''
                            }}
                            disableFuture={ options.disableFuture }
                            disablePast={ options.disablePast }
                            format={ options.displayFormat || 'DD-MM-YYYY' }
                            required={ required }
                            disabled={ disabled }
                            error={ error }
                            value={ convertedValue }
                            invalidDateMessage={ '' }
                            minDateMessage={ '' }
                            maxDateMessage={ '' }
                            onBlur={ onBlur && (() => onBlur({ id, value: this.onChangeValue })) }
                            onFocus={ onFocus && (() => onFocus({ id, value: this.onChangeValue })) }
                            onChange={ onChange }
                            variant={ options.pickerVariant || 'inline' }
                            inputVariant={ options.variant || 'outlined'}
                            placeholder={ placeholder }
                            { ...optionalProps }
                        />
                    </MuiPickersUtilsProvider>
                    { helperText ? <FormHelperText
                        classes={{
                            root: classes.helperContainer || ''
                        }}
                    >{ helperText }</FormHelperText> : null }
                    { errorText ? <FormHelperText
                        classes={{
                            root: classes.errorContainer || ''
                        }}
                    >{ errorText }</FormHelperText> : null }
                </FormControl>
            </React.Fragment>
        );
    }
}

DateField.propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    emptyValue: PropTypes.any,
    placeholder: PropTypes.any,
    error: PropTypes.bool,
    errorText: PropTypes.string,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    options: PropTypes.shape({
        variant: PropTypes.string,
        useStepViews: PropTypes.bool,
        disableFuture: PropTypes.bool,
        disablePast: PropTypes.bool,
        clearable: PropTypes.bool,
        displayFormat: PropTypes.string,
        pickerVariant: PropTypes.string,
        minDate: PropTypes.instanceOf(moment),
        maxDate: PropTypes.instanceOf(moment),
        autoOk: PropTypes.bool
    }),
    uiSchema: PropTypes.shape({
        classes: PropTypes.shape({
            fieldSet: PropTypes.string,
            dateField: PropTypes.string,
            titleContainer: PropTypes.string,
            helperContainer: PropTypes.string,
            errorContainer: PropTypes.string
        })
    }),
    inputValue: PropTypes.instanceOf(moment),
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    helperText: PropTypes.string,
    onChange: PropTypes.func
};

DateField.defaultProps = {
    title: '',
    emptyValue: '',
    placeholder: '',
    error: false,
    errorText: '',
    required: false,
    disabled: false,
    options: {
        variant: 'outlined',
        useStepViews: false,
        disableFuture: false,
        disablePast: false,
        clearable: true,
        displayFormat: 'DD-MM-YYYY',
        pickerVariant: 'inline'
    },
    uiSchema: {},
    inputValue: '',
    helperText: ''
};
